module.exports = global["echarts"] = require("-!/www/tower/releases/20210628040636/node_modules/babel-loader/lib/index.js??ref--11-0!./echarts.min.js");